import { defineEntityContract, type EntityByIdRequests, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  UserCreateRequest,
  UserDeleteRequest,
  UserEditRequest,
} from 'shared/domain/messages/user/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { UserInDto } from './types/inDto';
import type { UserModel } from './types/model';

/**
 * User events. A created or edited user comes with the server's DTO (the
 * response handler maps both edit answers, permissions and personal data, to
 * it). The delete outcome stays `unknown`: the HTTP queue answers it with `true`.
 */
export type UserEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allUsers]: { hasAll?: boolean; items: UserModel[] };
  [DomainMessagesTypes.uploadedEntity]: UserInDto;
  [DomainMessagesTypes.updatedEntity]: UserInDto;
  [DomainMessagesTypes.deletedEntity]: unknown;
};

/**
 * One user for its details view, and the user changes: each change resolves
 * once queued, its outcome follows as an event with its `uniqueId`.
 */
export type UserRequests = EntityByIdRequests<UserModel> & {
  create: { request: UserCreateRequest; response: void };
  edit: { request: UserEditRequest; response: void };
  remove: { request: UserDeleteRequest; response: void };
};

export const userContract = defineEntityContract<UserModel, UserEvents, UserRequests>('userChannel', {
  collectionEvent: DomainMessagesTypes.allUsers,
});
